import { METRIC_KEYS, MetricComparison, MetricKey, MetricThreshold, MonthSelection, PropertyDataHealthRow, Thresholds } from "./types";

export function hasDifferentReforecast(row: PropertyDataHealthRow, baseMonth: MonthSelection): boolean {
    return row.reforecastYear !== baseMonth.year || row.reforecastStartMonthIndex !== baseMonth.monthIndex;
}

function isMetricOutlier(metric: MetricComparison, threshold: MetricThreshold): boolean {
    const pct = metric.percentChange;
    if (pct == null) {
        return false;
    }
    if (threshold.increase != null && pct > threshold.increase / 100) {
        return true;
    }
    if (threshold.decrease != null && pct < -Math.abs(threshold.decrease) / 100) {
        return true;
    }
    return false;
}

export function propertyOutlierMetrics(row: PropertyDataHealthRow, thresholds: Thresholds): MetricKey[] {
    const flagged: MetricKey[] = [];
    for (const key of METRIC_KEYS) {
        if (isMetricOutlier(row[key], thresholds[key])) {
            flagged.push(key);
        }
    }
    return flagged;
}

export function isPropertyOutlier(row: PropertyDataHealthRow, thresholds: Thresholds): boolean {
    return propertyOutlierMetrics(row, thresholds).length > 0;
}
